module.exports = __webpack_public_path__ + "static/media/cellfinate_works_results.de5c71e7.png";